import { render, staticRenderFns } from "./TransshipmentCharges.vue?vue&type=template&id=719e74bf&scoped=true"
import script from "./TransshipmentCharges.vue?vue&type=script&lang=js"
export * from "./TransshipmentCharges.vue?vue&type=script&lang=js"
import style0 from "./TransshipmentCharges.vue?vue&type=style&index=0&id=719e74bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719e74bf",
  null
  
)

export default component.exports